import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "../chartTemplate";
import * as d3 from "d3";
import * as crossfilter from "crossfilter2/crossfilter";
import reductio from "reductio";

const livestockChartFunc = (divRef, ndx) => {
  // wrap  text on the axis
  function wrap(text, width) {
    text.each(function () {
      var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text
          .text(null)
          .append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", dy + "em");
      while ((word = words.pop())) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text
            .append("tspan")
            .attr("x", 0)
            .attr("y", y)
            .attr("dy", ++lineNumber * lineHeight + dy + "em")
            .text(word);
        }
      }
    });
  }
  function regroup(dim, cols) {
    var _groupAll = dim.groupAll().reduce(
      function (p, v) {
        // add
        cols.forEach(function (c) {
          p[c] += v[c];
        });
        return p;
      },
      function (p, v) {
        // remove
        cols.forEach(function (c) {
          p[c] -= v[c];
        });
        return p;
      },
      function () {
        // init
        var p = {};
        cols.forEach(function (c) {
          p[c] = 0;
        });
        return p;
      }
    );
    return {
      all: function () {
        return d3.map(_groupAll.value()).entries();
      },
    };
  }
  const livestock_stat = ndx.dimension((d) => d.number_LV);
  const livestock_stat_grp = regroup(livestock_stat, [
    "number_LV",
    "products_LV_KG_Ltrs",
  ]);

  let compositeChart = dc.compositeChart(divRef);

  const BAR_PADDING = 0.1; // percentage the padding will take from the bar
  const RANGE_BAND_PADDING = 0.6; // padding between 'groups'
  const OUTER_RANGE_BAND_PADDING = 0.6; // padding from each side of the chart

  let sizing = (chart) => {
    chart.width(window.innerWidth).height(window.innerHeight).redraw();
  };

  let resizing = (chart) => (window.onresize = () => sizing(chart));

  let barPadding;
  let scaleSubChartBarWidth = (chart) => {
    let subs = chart.selectAll(".sub");

    if (typeof barPadding === "undefined") {
      // first draw only
      // to percentage
      barPadding = (BAR_PADDING / subs.size()) * 100;
      // each bar gets half the padding
      barPadding = barPadding / 2;
    }

    let startAt,
      endAt,
      subScale = d3.scaleLinear().domain([0, subs.size()]).range([0, 100]);

    subs.each(function (d, i) {
      startAt = subScale(i + 1) - subScale(1);
      endAt = subScale(i + 1);
      startAt += barPadding;
      endAt -= barPadding;
      d3.select(this)
        .selectAll("rect")
        .attr(
          "clip-path",
          `polygon(${startAt}% 0, ${endAt}% 0, ${endAt}% 100%, ${startAt}% 100%)`
        );
    });
  };
    //  format  the output to  2 decimal  places.
  var  f= d3.format(",.0f")

  let barChart1 = dc
    .barChart(compositeChart)
      .barPadding(0)
      .elasticY(true)
      .valueAccessor((d) => {
          if (d.value == 0) {
              return d.value
          } else {
              return Math.log10(d.value)
          }
         
      })
    // .label((d) => {
    //   if (d.key == "number_LV") {
    //     return "Number of Livestock (’*5)";
    //   } else {
    //     return "Product of Livestock (’000)Kg";
    //   }
    // })
  
    .title((d) =>{
      if(d.key == "number_LV"){
        return "No of livestock : " + f(d.value)
      }else{
        return "Lv products (Kgs /Ltrs) : " + f(d.value)
      }
    } )
    .colors(["#478187"]);

  // let barChart2 = dc
  //   .barChart(compositeChart)
  //   .barPadding(0)
  //   .valueAccessor((d) => d.value[1].value)
  //   .title((d) => d.key + `[${d.value[1].key}]: ` + d.value[1].value)
  //   .colors(["#6CA5BF"]);

  //   let barChart3 = dc
  //     .barChart(compositeChart)
  //     .barPadding(0)
  //     .valueAccessor((d) => d.value[2].value)
  //     .title((d) => d.key + `[${d.value[2].key}]: ` + d.value[2].value)
  //     .colors(["#47a64a"]);

  compositeChart
    .shareTitle(false)

    .width(300)
    .height(170)
    .transitionDuration(1500)
    .group(livestock_stat_grp)
    .colors(d3.scaleOrdinal().domain([0, 1]).range(["#F9E0A4", "#80AED5"]))
    ._rangeBandPadding(RANGE_BAND_PADDING)
    ._outerRangeBandPadding(OUTER_RANGE_BAND_PADDING)
    .x(d3.scaleOrdinal())
    .y(d3.scaleLinear().domain([0, 100]))
    .xUnits(dc.units.ordinal)
    .compose([barChart1])
    .elasticY(true)
    .on("pretransition", (chart) => {
      scaleSubChartBarWidth(chart);
    })
    // .on("renderlet", function (d) {
    //   compositeChart.selectAll("g.x.axis .tick text").call(wrap, 1);
    // })
    .on("filtered", (chart, filter) => {
      console.log(chart, filter);
    })
    .on("preRedraw", (chart) => {
      chart.rescale();
    })
    .on("preRender", (chart) => {
      chart.rescale();
    });
  // .render();
  compositeChart.yAxis().ticks(0);
  //   sizing(compositeChart);
  //   resizing(compositeChart);
  compositeChart.xAxis().tickFormat(function (v) {
    if (v == "number_LV") {
      return "No of Livestocks";
    } else if (v == "products_LV_KG_Ltrs") {
      return "Products (Kgs/Ltrs)";
    }
  });
  return compositeChart;
};

export const LivestockStatChart = (props) => (
  <ChartTemplate
    chartFunction={livestockChartFunc}
    //  title="Crop Statistics"
  />
);
